export const GLOBAL = "GLOBAL";
export const CUSTOM = "CUSTOM";